import { lazy, Suspense } from 'react';

import type { DayCalendarProps } from './DayCalendarImpl';

// react-day-picker and its locales stay out of the main bundle until a calendar opens.
const Impl = lazy(() => import('./DayCalendarImpl'));

export function DayCalendar(props: DayCalendarProps) {
  return (
    <Suspense fallback={<div style={{ minHeight: '17rem' }} aria-busy="true" />}>
      <Impl {...props} />
    </Suspense>
  );
}
